export default "__VITE_ASSET__CQR1U$BQ__"